import ContentFeature from './ContentFeature'
export type { ContentFeatureProps } from './ContentFeature'
export default ContentFeature
